import { render, staticRenderFns } from "./ContactLists.vue?vue&type=template&id=38bef711&scoped=true&"
import script from "./ContactLists.vue?vue&type=script&lang=js&"
export * from "./ContactLists.vue?vue&type=script&lang=js&"
import style0 from "./ContactLists.vue?vue&type=style&index=0&id=38bef711&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bef711",
  null
  
)

export default component.exports